<template>
	<RouterLink v-if="to" :to="to" class="mdc-button" :class="[variant, classes].join(` `)">
		<span class="mdc-button__ripple"></span>
		<i class="material-icons mdc-button__icon" aria-hidden="true" v-html="pre" v-if="pre"></i>
		<i class="material-icons icons material-icons--spin mdc-button__icon" aria-hidden="true" v-html="`support`" v-if="loading"></i>
		<span class="mdc-button__label"><slot /></span>
		<i class="material-icons mdc-button__icon" aria-hidden="true" v-html="post" v-if="post"></i>
	</RouterLink>
	<a v-else-if="href" :href="href" :target="target" class="mdc-button" :type="type" :class="[variant, classes].join(` `)">
		<span class="mdc-button__ripple"></span>
		<i class="material-icons mdc-button__icon" aria-hidden="true" v-html="pre" v-if="pre"></i>
		<i class="material-icons icons material-icons--spin mdc-button__icon" aria-hidden="true" v-html="`support`" v-if="loading"></i>
		<span class="mdc-button__label"><slot /></span>
		<i class="material-icons mdc-button__icon" aria-hidden="true" v-html="post" v-if="post"></i>
	</a>
	<button v-else class="mdc-button" :type="type" :class="[variant, classes].join(` `)">
		<span class="mdc-button__ripple"></span>
		<i class="material-icons mdc-button__icon" aria-hidden="true" v-html="pre" v-if="pre"></i>
		<i class="material-icons icons material-icons--spin mdc-button__icon" aria-hidden="true" v-html="`support`" v-if="loading"></i>
		<span class="mdc-button__label"><slot /></span>
		<i class="material-icons mdc-button__icon" aria-hidden="true" v-html="post" v-if="post"></i>
	</button>
</template>

<script>
import { RouterLink } from 'vue-router'

export default {
	name: 'Button',
	components: {
		RouterLink,
	},
	props: {
		look: {
			type: String,
			default: 'flat',
			validator(val) {
				return ['raised','outline','flat','text','form','form-outline','form-text'].includes(val)
			},
		},

		pre: {
			type: String,
			default: '',
		},
		post: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: 'button',
		},
		to: {
			type: Object,
			default: null,
		},
		href: String,
		target: String,
		notice: Boolean,
		warning: Boolean,
		loading: Boolean,
	},
	computed: {
		variant() {
			switch(this.look) {
				case 'text':
					return
				case 'outline':
					return 'mdc-button--outlined'
				case 'raised':
					return 'mdc-button--raised'
				case 'form':
					return 'mdc-button--unelevated mdc-button--form'
				case 'form-outline':
					return 'mdc-button--outlined mdc-button--form'
				case 'form-text':
					return 'mdc-button--form'
				default:
				case 'flat':
					return 'mdc-button--unelevated'
			}
		},
		classes() {
			if (this.notice) {
				return 'mdc-button--notice'
			}
			if (this.warning) {
				return 'mdc-button--warning'
			}
		},
	},
}
</script>

<style scoped lang="scss">
.mdc-button {
	&__label {
		line-height: 1;
	}
}
</style>
